import { set, reduce } from 'lodash/fp';
import { breakoutPermission } from '../../../helpers/permission';
import { fetchUserPermissions } from '../../sagas/permission/routines';
import createReducer from '../../../helpers/createReducer';

const initialState = {
  all: [],
  fetching: false,
  fetched: false,
  fetchingError: null
};

export const fetchUserPermissionHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, fetching: true, fetched: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) => {
    const permissions = reduce(
      (all, permission) => [...all, ...breakoutPermission(permission)],
      [],
      response.items
    );
    return set('all', permissions, state);
  },
  [routine.FAILURE]: (state, { error }) => set('fetchingError', error, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

export default createReducer(initialState, {
  ...fetchUserPermissionHandler(fetchUserPermissions)
});
